<div class="style-picker" [class]="{'style-picker-borderless': type === 'project'}">
  <div class="style-picker-tags">
    @for (category of styleCategories(); track category) {
      <div (click)="selectCategoryFilter(category)">
        <app-tag [type]="category" [active]="category === categoryFilter()"></app-tag>
      </div>
    }
  </div>
  <div class="style-picker-imgs" (mouseleave)="onMouseLeave()">
    @for (style of filterStylesByCategory(); track style.id) {
      <div
        (mouseenter)="onStyleHover(style)"
        (mouseleave)="onStyleItemLeave(style)"
        (click)="onStyleClick(style)"
        class="cursor-pointer"
        [class.style-picker-img]="style.id === selectedStyle()?.id"
      >
        <img class="border-round-2xl" [src]="style.media.thumb" [alt]="style.name" />
        <div class="text-xs font-medium text-center">{{style.name}}</div>
      </div>
    }
  </div>
</div>
